import React from "react";
import { Link, useNavigate } from "react-router-dom";

const Footer = () => {

  const navigate = useNavigate(); // Place the useNavigate hook at the top level
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  const scrollToSection = (id) => {
    const handleScroll = () => {
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100); // Delay to ensure the DOM is updated after navigation
    };

    return () => {
      if (window.location.pathname !== '/') {
        navigate('/');
        handleScroll();
      } else {
        handleScroll();
      }
    };
  };


  const scrollToAbout = scrollToSection('about');
  return (
    
    <footer>
     

      <div className="top_footer" id="contact">
        {/* animation line */}
        {/* <div className="anim_line dark_bg">
          {[...Array(9)].map((_, index) => (
            <span key={index}>
              <img
                src="https://playpro.pk/images/anim_line.png"
                alt="anim_line"
              />
            </span>
          ))}
        </div> */}
        {/* container start */}
        <div className="container">
          {/* row start */}
          <div className="row">
            {/* footer link 1 */}
            <div className="col-lg-4 col-md-6 col-12">
              <div className="abt_side">
                <div className="logo">
                  <img
                    src="https://playpro.pk/images/playprologowhite.png"
                    alt="image"
                  />
                </div>
                <p>
                  Welcome to PlayPro, Pakistan's top hub for sports enthusiasts.
                  Whether you're a pro or a beginner, PlayPro has everything you
                  need to improve your game, connect with others, and enjoy the
                  excitement of sports.
                </p>

                <ul className="social_media">
                  <li>
                    <a
                      href="https://www.facebook.com/playpro.pk"
                      target="_blank"
                    >
                      <i className="icofont-facebook"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.instagram.com/playpro_pk/"
                      target="_blank"
                    >
                      <i className="icofont-instagram"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.linkedin.com/company/playpro-pk/about/"
                      target="_blank"
                    >
                      <i className="icofont-linkedin"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>

            {/* footer link 2 */}
            <div className="col-lg-3 col-md-6 col-12">
              <div className="links">
                <h3>Useful Links</h3>
                <ul>
                  <li>
                    <a href="/">Home</a>
                  </li>
                  <li className="nav-item has_dropdown">
  <a 
    className="nav-link" 
    onClick={scrollToAbout} 
    style={{ color: 'white' , cursor: 'pointer'  }}
  >
    About
  </a>
</li>

                  <li>
                    {/* <a href="https://playpro.pk/blogs-and-news">Blog</a> */}
                    {/* <Link to="/contact-us">Blog</Link> */}
                  </li>
                  <li>
                    <Link to="/contact-us" onClick={scrollToTop}>Contact us</Link>
                  </li>
                </ul>
              </div>
            </div>

            {/* footer link 3 */}
            <div className="col-lg-3 col-md-6 col-12">
              <div className="links">
                <h3>Help & Suport</h3>
                <ul>
                <li>
  <Link to="/faq" onClick={scrollToTop}>FAQs</Link>
</li>
                  <li>
                    {/* <a href="https://playpro.pk/terms-and-condition">
                      Terms & conditions
                    </a> */}
                     <Link to="/terms-and-condition" onClick={scrollToTop}>Terms & conditions</Link>
                  </li>
                  <li>
                    {/* <a href="https://playpro.pk/privacy-policy">
                      Privacy policy
                    </a> */}
                     <Link to="/privacy-policy" onClick={scrollToTop}> Privacy policy</Link>
                  </li>
                </ul>
              </div>
            </div>

            {/* footer link 4 */}
            <div className="col-lg-2 col-md-6 col-12">
              <div className="try_out">
                <h3>Let's Try Out</h3>
                <ul className="app_btn">
                  <li>
                    <a
                      href="https://apps.apple.com/us/app/playpro-app/id6612028849"
                      target="_blank"
                    >
                      <img
                        src="https://playpro.pk/images/appstore_blue.png"
                        alt="image"
                      />
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://play.google.com/store/apps/details?id=com.nascent.playpro&hl=en"
                      target="_blank"
                    >
                      <img
                        src="https://playpro.pk/images/googleplay_blue.png"
                        alt="img"
                      />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          {/* row end */}
        </div>
        {/* container end */}
      </div>

      {/* last footer */}
      <div className="bottom_footer">
        {/* container start */}
        <div className="container">
          {/* row start */}
          <div className="row">
            <div className="col-md-6">
              <p>Copyrights © 2025 PlayPro. All rights reserved.</p>
            </div>
          </div>
          {/* row end */}
        </div>
        {/* container end */}
      </div>

      {/* go top button */}
      {/* <div className="go_top">
        <span>
          <img src="images/go_top1.png" alt="image" />
        </span>
      </div> */}
    </footer>
  );
};

export default Footer;


